export const BACKGROUND_BLUR_INTENSITY_PRESETS: Array<{
	label: string;
	value: number;
}> = [
	{ label: "Легкое", value: 100 },
	{ label: "Среднее", value: 200 },
	{ label: "Сильное", value: 500 },
] as const;

// Only used as a render-time fallback when a stored `background.blurIntensity` is missing (see
// scene-builder.ts's `background.blurIntensity ?? DEFAULT_BACKGROUND_BLUR_INTENSITY`) — a normal
// preset click always supplies an explicit value (100/200/500, see the presets above) and never
// hits this. Must match LEGACY_DEFAULT_BACKGROUND_BLUR_INTENSITY in the v20→v21 storage migration
// (services/storage/migrations/transformers/v20-to-v21.ts) — that migration established the
// current post-v21 intensity scale (raw intensity / 5 = blur sigma in px) and defined 50 as its
// "no stored value" fallback; this constant was never updated to match when that scale shipped,
// so it was producing a blur ~5x weaker than intended (sigma ≈2px instead of ≈10px) for any
// "blur" background missing an explicit intensity.
export const DEFAULT_BACKGROUND_BLUR_INTENSITY = 50;
